import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { GuestLinkBaseResponseSchema } from './guest-link-base-response.dto';
import { GuestResponseSchema } from './guest-list-response.dto';
const GuestWithLinksResponseSchema = GuestResponseSchema.extend({
    links: z.array(GuestLinkBaseResponseSchema),
});
export class GuestWithLinksResponseDto extends createZodDto(GuestWithLinksResponseSchema) {
}
